export default __webpack_public_path__ + "static/Taichi100M-8123a9f6bf4be00a2a495cfe9de408a4.mp4";